export enum FILE_UPLOAD_STATUS {
  NEW = 'Ready For Upload',
  PENDING = 'Uploading...',
  SUCCESS = 'Upload Succeeded!',
  FAILURE = 'Upload Failed.'
}

export enum FILE_VALIDATION_FAILURE_STATUS {
  FILE_SIZE_TOO_BIG = 'File Size Too Big.',
  FILE_TYPE = 'File Type Incorrect.'
}

export interface DisplayableFile {
    name: string;
    size: number | string;
    status: FILE_UPLOAD_STATUS | FILE_VALIDATION_FAILURE_STATUS;
    documentRecord?: string;
    documentDescription?: string;
}

/** Existing Docs - this interface supports inclusion of extra fields */
interface DynamicKeys {
  [key: string]: any;
}
export interface ExistingDocs extends DynamicKeys {
  displayableFileObj: DisplayableFile
  doctype: string;
}